<template>
    <ViewBonAncien/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
    import ViewBonAncien from "@/components/GesCom/BonAncien/ViewBonAncien.vue";

    export default defineComponent({
      name: "ViewBonAncienPage",
      components: {
        ViewBonAncien,
      },
    });
  </script>